module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "site-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "site-logo",
    on: {
      "click": _vm.goIndex
    }
  }, [_c('span', {
    staticClass: "logo"
  }), _vm._v(_vm._s(this.messages[this.lang].siteName))]), _vm._v(" "), _c('nav', {
    staticClass: "site-nav"
  }, [_c('a', {
    attrs: {
      "href": '/api.html#/' + this.lang
    }
  }, [_vm._v(_vm._s(this.messages[this.lang].navApi))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/dashboard.html#/' + this.lang
    }
  }, [_vm._v(_vm._s(this.messages[this.lang].navDashboard))]), _vm._v(" "), (this.$parent.isLogin) ? _c('div', {
    staticClass: "user-info"
  }, [_c('i', {
    staticClass: "icon icon-user"
  }), _c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(this.$parent.userName))]), _c('span', {
    staticClass: "sep"
  }, [_vm._v("|")]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.goLogout
    }
  }, [_vm._v(_vm._s(this.messages[this.lang].logout))])]) : _c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v(_vm._s(this.messages[this.lang].login))])]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('select', {
    on: {
      "change": _vm.travel
    }
  }, _vm._l((this.websites), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.name,
        "selected": item.name == _vm.website
      }
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3567293b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteHeader.vue
// module id = 704
// module chunks = 8